(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-bundle"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const bundleItems = [];
  const addBundleBtn = document.getElementById('add-bundle-to-cart');
  
  // Initialize all product elements
  const productElements = document.querySelectorAll('[data-bundle-product="true"]');
  
  // Add event listeners to all "Add to Bundle" buttons
  document.querySelectorAll('.bundle-add-btn').forEach(button => {
    button.addEventListener('click', function() {
      const productId = this.dataset.productId;
      const productElement = this.closest('[data-bundle-product="true"]');
      const variantId = getSelectedVariantId(productElement);
      
      if (!variantId) {
        alert('Please select all options for this product');
        return;
      }
      
      const itemIndex = bundleItems.findIndex(item => item.id === productId);
      
      if (itemIndex > -1) {
        // Remove from bundle
        bundleItems.splice(itemIndex, 1);
        this.textContent = 'Add to Bundle';
        productElement.classList.remove('bundle-selected');
      } else if (bundleItems.length < 4) {
        // Add to bundle
        bundleItems.push({
          id: productId,
          variantId: variantId,
          quantity: 1,
          element: productElement
        });
        this.textContent = 'Remove from Bundle';
        productElement.classList.add('bundle-selected');
      }
      
      updateBundleUI();
    });
  });
  
  // Update variant selection when options change
  document.querySelectorAll('.bundle-variant-selector').forEach(select => {
    select.addEventListener('change', function() {
      const productElement = this.closest('[data-bundle-product="true"]');
      const productId = productElement.dataset.productId;
      const addButton = productElement.querySelector('.bundle-add-btn');
      
      // If product is in bundle, update its variant
      const bundleItem = bundleItems.find(item => item.id === productId);
      if (bundleItem) {
        const newVariantId = getSelectedVariantId(productElement);
        if (newVariantId) {
          bundleItem.variantId = newVariantId;
        } else {
          // If variant becomes invalid, remove from bundle
          const itemIndex = bundleItems.findIndex(item => item.id === productId);
          if (itemIndex > -1) {
            bundleItems.splice(itemIndex, 1);
            addButton.textContent = 'Add to Bundle';
            productElement.classList.remove('bundle-selected');
            updateBundleUI();
          }
        }
      }
    });
  });
  
  // Handle adding bundle to cart
  addBundleBtn.addEventListener('click', async function() {
    if (bundleItems.length !== 4 || this.disabled) return;
    
    const button = this;
    button.disabled = true;
    button.textContent = 'Adding...';
    
    try {
      // Add items sequentially
      for (const item of bundleItems) {
        await addItemToCart(item.variantId, item.quantity);
      }
      
      // Redirect to cart after all items are added
      window.location.href = '/cart';
    } catch (error) {
      console.error('Error adding bundle to cart:', error);
      alert('There was an error adding your bundle to cart. Please try again.');
      button.disabled = false;
      button.textContent = 'Add Bundle to Cart (50% Off)';
    }
  });
  
  // Helper function to add item to cart
  function addItemToCart(variantId, quantity) {
    return new Promise((resolve, reject) => {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: {
            
            'Bundle Discount': '50%'
          }
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Failed to add item');
        return response.json();
      })
      .then(data => resolve(data))
      .catch(error => reject(error));
    });
  }
  
  // Helper function to get selected variant ID
  function getSelectedVariantId(productElement) {
    try {
      const variants = JSON.parse(productElement.dataset.variants);
      const selects = productElement.querySelectorAll('.bundle-variant-selector');
      const selectedOptions = Array.from(selects).map(select => select.value);
      
      // Find variant that matches all selected options
      const matchedVariant = variants.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });
      
      return matchedVariant ? matchedVariant.id : null;
    } catch (e) {
      console.error('Error getting variant ID:', e);
      return null;
    }
  }
  
  // Update UI based on bundle state
  function updateBundleUI() {
    // Update progress bar
    const progress = (bundleItems.length / 4) * 100;
    document.querySelector('.progress-bar').style.width = `${progress}%`;
    
    // Update counter
    document.querySelector('.bundle-progress span').textContent = 
      `${bundleItems.length}/4 products selected`;
    
    // Update add bundle button
    if (bundleItems.length === 4) {
      addBundleBtn.disabled = false;
      addBundleBtn.classList.add('enabled');
    } else {
      addBundleBtn.disabled = true;
      addBundleBtn.classList.remove('enabled');
    }
    
    // Update all add buttons
    document.querySelectorAll('.bundle-add-btn').forEach(button => {
      const productId = button.dataset.productId;
      const isInBundle = bundleItems.some(item => item.id === productId);
      
      button.disabled = !isInBundle && bundleItems.length >= 4;
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
